<button (click)="clickInput()"></button>
<input type="file" accept="application/pdf" name="pdf" id="pdf" (change)="onFileChange($event)">